import { createContext, useContext } from 'react';
import { ApolloError } from '@apollo/client';
import noop from 'utils/noop';
import { SMSSender } from 'modules/graphql/types';

export interface SMSSendersQueryContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: () => void;
  smsSenders: SMSSender[];
}

export const SMSSendersQueryContext = createContext<SMSSendersQueryContextState>({
  errorMessage: '',
  hasError: false,
  isLoading: true,
  refetch: noop,
  smsSenders: [],
});

export const useSMSSendersQueryContext = () => useContext(SMSSendersQueryContext);
